import React from 'react';
export function Footer() {
  return <footer className="w-full bg-plum-deep" data-id="element-92" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-93" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl font-bold text-gold" data-id="element-94" data-mp="3ghc2o28413o8">
          Memory Care <span className="italic" data-id="element-95" data-mp="32pfgsfx1bq0a">Activity Ready</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/75" data-id="element-96" data-mp="36oo9dhgc9hu9">
          Every Stage, Every Resident — because no one should be left out of
          the room.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/75" data-id="element-97" data-mp="38h5b9u0hiky">
          <a href="mailto:help@iclcollective.com" className="hover:text-white hover:underline" data-id="element-98" data-mp="3lelybzm3ebki">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-plum-line pt-5 text-xs leading-relaxed text-white/55" data-id="element-99" data-mp="29zgjjx8osmkj">
          Memory Care Activity Ready is an educational resource for activity
          professionals. It supports your community&apos;s care plan and your
          professional judgment. It is not therapy or treatment and does not
          replace direction from nursing, physical therapy or dietary staff.
          Anything involving food, movement or touch should be confirmed with
          nursing first. Not affiliated with any named program or method. No
          results for behavior, memory or health are promised, and use of this
          material does not guarantee any inspection or survey outcome. ©
          Memory Care Activity Ready 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}